import type { RouteRecordRaw } from 'vue-router'

export const routes: RouteRecordRaw[] = [
  {
    path: '/products',
    name: 'products',
    meta: {
      title: 'Products'
    },
    component: () => import('@/views/products/ProductListView.vue')
  },
  {
    path: '/products/create',
    name: 'product-create',
    meta: {
      title: 'Create Product'
    },
    component: () => import('@/views/products/ProductCreateView.vue')
  },
  {
    path: '/products/:id',
    name: 'product-edit',
    props: true,
    meta: {
      title: 'Edit Product'
    },
    redirect: ({ params }) => {
      return {
        name: 'product-edit-section',
        params: {
          ...params,
          section: 'info'
        }
      }
    },
    component: () => import('@/views/products/ProductEditView.vue'),
    children: [
      {
        path: '/products/:id/f/:section/:action/:actionId',
        name: 'product-edit-section-action',
        props: true,
        meta: {
          title: 'Edit Product'
        },
        component: () => import('@/views/products/ProductEditView.vue')
      },
      {
        path: '/products/:id/f/:section',
        name: 'product-edit-section',
        props: true,
        meta: {
          title: 'Edit Product'
        },
        component: () => import('@/views/products/ProductEditView.vue')
      }
    ]
  },
  {
    path: '/product-option-categories',
    name: 'product-option-categories',
    meta: {
      title: 'Product Option Categories'
    },
    component: () => import('@/views/product-option-categories/ProductOptionCategoryListView.vue')
  },
  {
    path: '/product-option-categories/create',
    name: 'product-option-category-create',
    meta: {
      title: 'Create Product Option Category'
    },
    component: () => import('@/views/product-option-categories/ProductOptionCategoryCreateView.vue')
  },
  {
    path: '/product-option-categories/:id',
    name: 'product-option-category-edit',
    props: true,
    meta: {
      title: 'Edit Product Option Category'
    },
    component: () => import('@/views/product-option-categories/ProductOptionCategoryEditView.vue')
  },
  {
    path: '/product-options',
    name: 'product-options',
    meta: {
      title: 'Product Options'
    },
    component: () => import('@/views/product-options/ProductOptionListView.vue')
  },
  {
    path: '/product-options/create',
    name: 'product-option-create',
    meta: {
      title: 'Create Product Option'
    },
    component: () => import('@/views/product-options/ProductOptionCreateView.vue')
  },
  {
    path: '/product-options/:id',
    name: 'product-option-edit',
    props: true,
    meta: {
      title: 'Edit Product Option'
    },
    component: () => import('@/views/product-options/ProductOptionEditView.vue'),
    children: [
      {
        path: '/product-options/:id/:section',
        name: 'product-option-edit-section',
        props: true,
        meta: {
          title: 'Edit Product Option'
        },
        component: () => import('@/views/product-options/ProductOptionEditView.vue')
      }
    ]
  }
]

export default routes
